import { axios } from "./axios";
import Client from "./client";

export const client = new Client(axios);

export function setToken(token: string) {
  axios.defaults.headers["Authorization"] = token;
}

export function resetToken() {
  delete axios.defaults.headers["Authorization"];
}
